// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Lq1RV","title":"styles_title__1PBrt"};